import { SettingOutlined } from '@ant-design/icons';
import { Button, Col, Form, Modal, Row, Spin, Switch } from 'antd';
import React, { CSSProperties, useCallback, useEffect, useState } from 'react';
import GridLayout, { Layout } from 'react-grid-layout';
import { SizeMe } from 'react-sizeme';
import { apiClient } from '../../utils';
import { StatisticsWidget, WelcomeWidget } from './widgets';

export function HomePage() {
  const [widgetsLoading, setWidgetsLoading] = useState(false);
  const [widgetsLayout, setWidgetsLayout] = useState<Layout[]>();
  const [widgetsInitial, setWidgetsInitial] = useState(true);
  const [widgetsModalOpen, setWidgetsModalOpen] = useState(false);

  const defaultLayout = useCallback(
    () => [
      { i: 'welcome', x: 0, y: 0, w: 1, h: 3 },
      // { i: 'savedSearches', x: 1, y: 0, w: 1, h: 3 },
      { i: 'statistics', x: 2, y: 0, w: 1, h: 3 },
      { i: 'report1', x: 0, y: 2, w: 2, h: 4 },
    ],
    [],
  );

  const postWidgetsLayout = (newWidgetsLayout: Layout[]) => {
    apiClient
      .put('users/me/settings/widgets', { widgetsLayout: JSON.stringify(newWidgetsLayout) })
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setWidgetsLoading(false);
      });
  };

  const loadWidgetsLayout = useCallback(() => {
    setWidgetsLoading(true);
    apiClient
      .get('users/me/settings/widgets')
      .then(response => {
        if (response.data) {
          setWidgetsLayout(response.data as Layout[]);
        } else {
          setWidgetsLayout(defaultLayout);
        }
      })
      .catch(() => {})
      .finally(() => {
        setWidgetsLoading(false);
      });
  }, [defaultLayout]);

  useEffect(() => {
    loadWidgetsLayout();
  }, [loadWidgetsLayout]);

  const onLoayoutChange = (newWidgetsLayout: Layout[]) => {
    setWidgetsLayout(newWidgetsLayout);
    if (!widgetsInitial) {
      postWidgetsLayout(newWidgetsLayout);
    }
    setWidgetsInitial(false);
  };

  const openWidgetsModal = () => {
    setWidgetsModalOpen(true);
  };

  const closeWidgetsModal = () => {
    setWidgetsModalOpen(false);
  };

  const onWidgetsSwitchChange = (key: string, active: boolean) => {
    if (active) {
      const newLayout = widgetsLayout ? [...widgetsLayout] : ([] as Layout[]);
      const firstColumnItemsHeight =
        newLayout
          .filter(w => w.x === 0)
          .map(w => w.h)
          .reduce((a, b) => a + b, 0) || 0;
      newLayout.push({
        i: key,
        x: 0,
        y: firstColumnItemsHeight,
        w: 1,
        h: 3,
      });
      setWidgetsLayout(newLayout);
    } else {
      const newLayout = widgetsLayout?.filter(w => w.i !== key);
      setWidgetsLayout(newLayout);
    }
  };

  const widgetStyle: CSSProperties = {
    border: '1px solid #ddd',
    borderRadius: '5px',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
  };

  return (
    <Spin spinning={widgetsLoading} style={{ paddingTop: '5rem' }}>
      {widgetsLayout && (
        <>
          <SizeMe>
            {({ size }) => (
              <GridLayout
                className="layout"
                layout={widgetsLayout}
                cols={3}
                rowHeight={70}
                width={size.width || 1200}
                margin={[20, 20]}
                onLayoutChange={onLoayoutChange}
              >
                {widgetsLayout.some(w => w.i === 'welcome') && (
                  <div style={widgetStyle} key="welcome">
                    <WelcomeWidget />
                  </div>
                )}
                {widgetsLayout.some(w => w.i === 'statistics') && (
                  <div style={widgetStyle} key="statistics">
                    <StatisticsWidget />
                  </div>
                )}
                {/* {widgetsLayout.some(w => w.i === 'savedSearches') && (
                  <div style={widgetStyle} key="savedSearches">
                    <SavedSearchesWidget />
                  </div>
                )} */}
              </GridLayout>
            )}
          </SizeMe>
          <Row justify="end" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
            <Col span={2} style={{ textAlign: 'right', padding: '1rem' }}>
              <Button type="default" shape="circle" icon={<SettingOutlined />} onClick={openWidgetsModal} />
            </Col>
          </Row>
          <Modal
            title="Ana sayfa widget seçenekleri"
            visible={widgetsModalOpen}
            footer={null}
            onCancel={closeWidgetsModal}
            destroyOnClose={true}
          >
            <WidgetsSwitches widgetsLayout={widgetsLayout} onChange={onWidgetsSwitchChange} />
          </Modal>
        </>
      )}
    </Spin>
  );
}

function WidgetsSwitches(props: { widgetsLayout: Layout[]; onChange: (key: string, active: boolean) => void }) {
  const widgetList = [
    { key: 'welcome', name: 'Hoşgeldiniz' },
    { key: 'statistics', name: 'İstatistikler' },
    // { key: 'savedSearches', name: 'Kaydedilmiş aramalar' },
  ];

  const onChange = (active: boolean, key: string) => {
    props.onChange(key, active);
  };

  return (
    <>
      {widgetList.map(w => (
        <Form.Item label={w.name} valuePropName="checked" key={w.key}>
          <Switch onChange={active => onChange(active, w.key)} defaultChecked={props.widgetsLayout?.some(l => l.i === w.key)} />
        </Form.Item>
      ))}
    </>
  );
}
